export default __webpack_public_path__ + "static/media/LesswasteII.5dfba334.png";